<dynamic-form
  [apiName]="apiName"
  [group]="formGroup"
  [label]="label"
  [areaName]="areaName"
  [model]="model"
  [columns]="headerColumns"
  [isShowModal]="false"
  (valueChangeByApiName)="onChange($event)"
  (cancelChange)="cancel()"
  (submitChange)="save()">
  <ng-container class="content" *ngIf="GoodsFormulaHeadersColumns && GoodsFormulaHeadersColumns.length > 0">
    <div class="grid-wapper">
      <div class="headers">
        <div class="d-flex align-items-center">
          <i class="icon-chevron_left-o"></i>
          آنالیز کالا
        </div>
        <kgrid
          #goodsFormulaHeaders
          id="GoodsFormulaHeaders"
          class="goods-formula-headers"
          [apiName]="apiName"
          [areaName]="areaName"
          [label]="label"
          [noToolBar]="true"
          [groupable]="false"
          [pagingSize]="1000"
          [actions]="analysisActions"
          [actionTregger]="onanalysisActionClick"
          [paging]="false"
          name="GoodsFormulaHeaders"
          [columns]="GoodsFormulaHeadersColumns"
          [dataList]="model.GoodsFormulaHeaders"
          (onRefreshData)="refresh()"
          (onRowSelected)="HeaderRowSelected($event)"
          (onDelete)="onDeleteGoodsFormulaHeader($event)"
          (onCreate)="onCreateGoodsFormulaHeader($event)"
          (onEdit)="onEditGoodsFormulaHeader($event)"
          reportName="GoodsFormulaHeaders"
          [isCopy]="true"
          (preCopy)="copy($event)">
        </kgrid>
      </div>
      <div class="details">
        <div class="d-flex align-items-center">
          <i class="icon-chevron_left-o"></i>
          اجزاء تشکیل دهنده کالای {{ CurrentGoodsFormulaHeader?.Title }}
        </div>
        <kgrid
          *ngIf="actions && actions.length > 0"
          #goodsFormulaDetail
          id="GoodsFormulaDetails"
          class="goods-formula-details"
          [areaName]="areaName"
          [label]="label"
          [noToolBar]="true"
          [groupable]="false"
          name="GoodsFormulaDetails"
          [paging]="false"
          [pagingSize]="1000"
          [hasReport]="false"
          [actions]="actions"
          [actionTregger]="onActionClick"
          [columns]="GoodsFormulaDetailsColumns"
          [dataList]="GoodsFormulaDetails"
          aggregatesColumnName="StandardAmount"
          (onRefreshData)="refresh()"
          (onRowSelected)="DetailRowSelected($event)"
          (onCreate)="onCreateGoodsFormulaDetail($event)"
          (onDelete)="onDeleteGoodsFormulaDetail($event)"
          (onEdit)="onEditGoodsFormulaDetail($event)"
          reportName="GoodsFormulaDetails">
        </kgrid>
      </div>
    </div>
  </ng-container>
</dynamic-form>
